import { defineComponent as _defineComponent } from 'vue';
import { BDropdown } from "bootstrap-vue";
import { computed, ref } from "vue";
import { prependPath } from "@/utils/redirect";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ContentOptions',
    props: {
        writable: { type: Boolean, default: true },
        isDataset: { type: Boolean, required: true },
        isDeleted: { type: Boolean, default: false },
        isHistoryItem: { type: Boolean, required: true },
        isVisible: { type: Boolean, default: true },
        state: { type: String, default: "" },
        itemUrls: { type: Object, required: true },
    },
    emits: ["display", "showCollectionInfo", "edit", "delete", "undelete", "unhide"],
    setup(__props, { emit }) {
        const props = __props;
        const deleteCollectionMenu = ref(null);
        const displayButtonTitle = computed(() => (displayDisabled.value ? "This dataset is not yet viewable." : "Display"));
        const displayDisabled = computed(() => ["discarded", "new", "upload", "queued"].includes(props.state));
        const editButtonTitle = computed(() => (editDisabled.value ? "This dataset is not yet editable." : "Edit attributes"));
        const editDisabled = computed(() => ["discarded", "new", "upload", "queued", "running", "waiting"].includes(props.state));
        const displayUrl = computed(() => prependPath(props.itemUrls.display));
        const editUrl = computed(() => prependPath(props.itemUrls.edit));
        const isCollection = computed(() => !props.isDataset);
        const canShowCollectionDetails = computed(() => props.itemUrls.showDetails);
        const showCollectionDetailsUrl = computed(() => prependPath(props.itemUrls.showDetails));
        function onDelete($event) {
            if (isCollection.value) {
                deleteCollectionMenu.value?.show();
            }
            else {
                onDeleteItem();
            }
        }
        function onDeleteItem() {
            emit("delete");
        }
        function onDeleteItemRecursively() {
            const recursive = true;
            emit("delete", recursive);
        }
        function onDisplay($event) {
            // Wrap display handler to allow ctrl/meta click to open in new tab
            // instead of triggering display.
            if ($event.ctrlKey || $event.metaKey) {
                window.open(displayUrl.value, "_blank");
            }
            else {
                emit("display");
            }
        }
        return { __sfc: true, props, emit, deleteCollectionMenu, displayButtonTitle, displayDisabled, editButtonTitle, editDisabled, displayUrl, editUrl, isCollection, canShowCollectionDetails, showCollectionDetailsUrl, onDelete, onDeleteItem, onDeleteItemRecursively, onDisplay, BDropdown };
    }
});
